var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col-md-4 left" }, [
            _c(
              "div",
              { staticClass: "title" },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("sidebar.saleorder")) +
                    "\n          "
                ),
                _vm.ready
                  ? [
                      _vm._v(
                        "\n            >\n            " +
                          _vm._s(_vm.sale.so_code) +
                          "\n          "
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8 right" }, [
            _vm.ready
              ? _c("div", { staticClass: "action" }, [
                  _vm.showOptionButton
                    ? _c("div", { staticClass: "dropdown item" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn no-bg dropdown-toggle text-secondary shake",
                            attrs: {
                              id: "dropdownMenuButton",
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-haspopup": "true",
                              "aria-expanded": "false"
                            }
                          },
                          [
                            _c("i", { staticClass: "fas fa-cog" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(_vm.$t("button.options")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-menu dropdown-menu-right",
                            attrs: { "aria-labelledby": "dropdownMenuButton" }
                          },
                          [
                            _vm.hasRoleDelete
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.openConfirmdeleteModal()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-trash text-danger"
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "text-danger" }, [
                                      _vm._v(_vm._s(_vm.$t("button.delete")))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown nodro item" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn no-bg text-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.openCloneModal()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fas fa-copy" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(_vm.$t("button.clone")))
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown item" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn no-bg dropdown-toggle text-secondary",
                        attrs: {
                          id: "dropdownMenuButton",
                          type: "button",
                          "data-toggle": "dropdown",
                          "aria-haspopup": "true",
                          "aria-expanded": "false"
                        }
                      },
                      [
                        _c("i", { staticClass: "fas fa-download" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(_vm.$t("button.download")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-menu dropdown-menu-right",
                        attrs: { "aria-labelledby": "dropdownMenuButton" }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function($event) {
                                return _vm.downloadPdf()
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "text-secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.filename", { string: "PDF" })
                                )
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown nodro item" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn no-bg text-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.openPrintModal()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fas fa-print" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(_vm.$t("button.print")))
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.sale.status == "padding" && _vm.hasRoleApprove
                    ? _c(
                        "div",
                        { staticClass: "dropdown item" },
                        [
                          [
                            _vm.sale.status == "padding"
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn no-bg dropdown-toggle text-warning",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "dropdown",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "false"
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "far fa-circle" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("status.so.padding"))
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.sale.status == "approved"
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn no-bg dropdown-toggle text-info",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "dropdown",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "false"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "far fa-check-circle"
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("status.so.approved"))
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.sale.status == "rejected"
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn no-bg dropdown-toggle text-danger",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "dropdown",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "false"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "far fa-times-circle"
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("status.so.rejected"))
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right"
                            },
                            [
                              _vm.sale.status == "padding"
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function($event) {
                                          return _vm.updateSaleStatus({
                                            so_id: _vm.sale.so_id,
                                            status: "approved"
                                          })
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "far fa-check-circle text-info",
                                        staticStyle: {
                                          position: "relative",
                                          left: "-7px"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "text-info" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.so.approve"))
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sale.status == "padding"
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function($event) {
                                          return _vm.updateSaleStatus({
                                            so_id: _vm.sale.so_id,
                                            status: "rejected"
                                          })
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "far fa-times-circle text-danger",
                                        staticStyle: {
                                          position: "relative",
                                          left: "-7px"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-danger" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("status.so.reject"))
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        2
                      )
                    : _c(
                        "div",
                        { staticClass: "dropdown nodro item" },
                        [
                          [
                            _vm.getSaleStatus(_vm.sale, _vm.$t, _vm.mixin)
                              .status == "padding"
                              ? _c("span", { staticClass: "text-warning" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getSaleStatus(
                                          _vm.sale,
                                          _vm.$t,
                                          _vm.mixin
                                        ).message
                                      ) +
                                      "\n              "
                                  )
                                ])
                              : _vm.getSaleStatus(_vm.sale, _vm.$t, _vm.mixin)
                                  .status == "completed"
                              ? _c("span", { staticClass: "text-success" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getSaleStatus(
                                          _vm.sale,
                                          _vm.$t,
                                          _vm.mixin
                                        ).message
                                      ) +
                                      "\n              "
                                  )
                                ])
                              : _vm.getSaleStatus(_vm.sale, _vm.$t, _vm.mixin)
                                  .status == "uncompleted"
                              ? _c("span", { staticClass: "text-info" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getSaleStatus(
                                          _vm.sale,
                                          _vm.$t,
                                          _vm.mixin
                                        ).message
                                      ) +
                                      "\n              "
                                  )
                                ])
                              : _c("span", { staticClass: "text-danger" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getSaleStatus(
                                          _vm.sale,
                                          _vm.$t,
                                          _vm.mixin
                                        ).message
                                      ) +
                                      "\n              "
                                  )
                                ])
                          ]
                        ],
                        2
                      )
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready
            ? [
                _c("WrapperDoc", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "form",
                        fn: function() {
                          return [
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("section-header", {
                                    attrs: {
                                      title: _vm.$t("message.customer"),
                                      subtitle:
                                        _vm.$t("series.so") +
                                        " " +
                                        _vm.sale.so_code
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.storecompanyperson"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("selectize", {
                                                attrs: {
                                                  default:
                                                    _vm.form.defaultCustomerId,
                                                  updateoption:
                                                    _vm.form
                                                      .updateOptionCustomer,
                                                  options:
                                                    _vm.form.optionCustomers,
                                                  multiple: false,
                                                  create: true,
                                                  loading:
                                                    _vm.form.loadingCustomer,
                                                  validation:
                                                    _vm.form
                                                      .trickValidationCustomer,
                                                  placeholder: _vm.$t(
                                                    "placeholder.selectorcreate"
                                                  ),
                                                  disabled: _vm.disabledForm
                                                },
                                                on: {
                                                  add: _vm.onAddedCustomer
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.pickedCustomerId,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "pickedCustomerId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.pickedCustomerId"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm.form.pickedCustomerId
                                    ? _c("div", { staticClass: "form-row" }, [
                                        _c("div", { staticClass: "col-md-6" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group row",
                                              staticStyle: { height: "100%" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.address"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("textarea", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form.customer
                                                            .address,
                                                        expression:
                                                          "form.customer.address"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    staticStyle: {
                                                      height:
                                                        "calc(100% - 37px)"
                                                    },
                                                    attrs: {
                                                      disabled: _vm.disabledForm
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.form.customer
                                                          .address
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.form.customer,
                                                          "address",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-6" }, [
                                          _c(
                                            "div",
                                            { staticClass: "form-group row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("message.tel")
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form.customer.tel,
                                                        expression:
                                                          "form.customer.tel"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      disabled:
                                                        _vm.disabledForm,
                                                      type: "text"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.form.customer.tel
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.form.customer,
                                                          "tel",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "form-group row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("message.email")
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form.customer
                                                            .email,
                                                        expression:
                                                          "form.customer.email"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      disabled:
                                                        _vm.disabledForm,
                                                      type: "text"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.form.customer.email
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.form.customer,
                                                          "email",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "form-group row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.taxpayerno"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form.customer
                                                            .tax_id,
                                                        expression:
                                                          "form.customer.tax_id"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      disabled:
                                                        _vm.disabledForm,
                                                      type: "text"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.form.customer.tax_id
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.form.customer,
                                                          "tax_id",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("section-header", {
                                    attrs: { title: _vm.$t("message.date") }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("message.date"))
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("BaseInputDatePicker", {
                                                attrs: {
                                                  disabled: _vm.disabledForm
                                                },
                                                model: {
                                                  value: _vm.form.created_at,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "created_at",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.created_at"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "apps.sales.message.saletype"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("BaseDropdown", {
                                                attrs: {
                                                  options: _vm.saleOptions,
                                                  disabled: _vm.disabledForm
                                                },
                                                model: {
                                                  value: _vm.form.sale_type,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "sale_type",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.sale_type"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col",
                                        on: {
                                          click: function($event) {
                                            _vm.isFocusOnInputScheduled = false
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group row" },
                                          [
                                            _c("div", { staticClass: "col" }, [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.credittype")
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm.form.selectedCredit !==
                                              "custom"
                                                ? _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.form
                                                              .selectedCredit,
                                                          expression:
                                                            "form.selectedCredit"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control custom-select",
                                                      attrs: {
                                                        disabled:
                                                          _vm.disabledForm
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.$set(
                                                            _vm.form,
                                                            "selectedCredit",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "cash"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.cash"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "days.15"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.creditdasys",
                                                                { number: 15 }
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "days.30"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.creditdasys",
                                                                { number: 30 }
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "days.60"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.creditdasys",
                                                                { number: 60 }
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "days.90"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.creditdasys",
                                                                { number: 90 }
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "custom"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.customcreditdays"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass: "input-group"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.form
                                                                .inputCustomCreditDay,
                                                            expression:
                                                              "form.inputCustomCreditDay"
                                                          }
                                                        ],
                                                        ref:
                                                          "custom_credit_days",
                                                        staticClass:
                                                          "form-control text-right number-only text-select-all",
                                                        staticStyle: {
                                                          "border-right": "none"
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.disabledForm,
                                                          type: "text"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.form
                                                              .inputCustomCreditDay
                                                        },
                                                        on: {
                                                          keyup:
                                                            _vm.keyupInputCustomCreditDay,
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              _vm.form,
                                                              "inputCustomCreditDay",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group-prepend"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn",
                                                              class: [
                                                                _vm.disabledForm
                                                                  ? "btn-light"
                                                                  : "btn-web"
                                                              ],
                                                              staticStyle: {
                                                                border:
                                                                  "1px solid #ced4da"
                                                              },
                                                              attrs: {
                                                                disabled:
                                                                  _vm.disabledForm,
                                                                type: "button"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.form.selectedCredit =
                                                                    "cash"
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "message.creditdasysbutton"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                              !_vm.disabledForm
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "far fa-times-circle"
                                                                  })
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                            ])
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.form.selectedCredit !== "cash"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "col scheduled",
                                            class: { disabled: false }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group row" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "col-md-12",
                                                    staticStyle: {
                                                      position: "relative"
                                                    }
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass: "overlay"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.scheduled_at"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("BaseInputDatePicker", {
                                                      attrs: {
                                                        availableDates: {
                                                          start:
                                                            _vm.form.created_at,
                                                          end: null
                                                        },
                                                        disabled:
                                                          _vm.disabledForm
                                                      },
                                                      on: {
                                                        dayclick: function(
                                                          $event
                                                        ) {
                                                          _vm.isFocusOnInputScheduled = true
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.scheduled_at,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "scheduled_at",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.scheduled_at"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("section-header", {
                                    attrs: {
                                      title: _vm.$t("message.orderlist")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("order", {
                                    attrs: {
                                      validation: _vm.form.trickValidation,
                                      data: _vm.form.orders,
                                      createAble: true,
                                      showProductImage: true,
                                      disabled: _vm.disabledForm,
                                      showTooltipTaxHint:
                                        _vm.showTooltipTaxHint,
                                      type: "so"
                                    },
                                    on: { submit: _vm.onSubmitOrder }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("section", { staticClass: "no-margin" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12" },
                                            [
                                              _c("b-form-textarea", {
                                                staticStyle: {
                                                  "min-height": "126px"
                                                },
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "placeholder.note"
                                                  ),
                                                  disabled: _vm.disabledForm
                                                },
                                                model: {
                                                  value: _vm.form.note,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "note",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.note"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6 pl-2" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-12 row no-padding no-margin"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 row no-margin no-padding"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-6 no-padding mb-2"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.total"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-6 no-padding mb-2 text-right"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.getNumber(
                                                            _vm.total.sub
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.total.discount > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 row no-margin no-padding"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-6 no-padding mb-2"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.discount"
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-6 no-padding mb-2 text-right"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.getNumber(
                                                                _vm.total
                                                                  .discount
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.total.discount > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 row no-margin no-padding"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-6 no-padding mb-2"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.discounted_total"
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-6 no-padding mb-2 text-right"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.getNumber(
                                                                _vm.total.sub -
                                                                  _vm.total
                                                                    .discount
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.total.taxes.vat.inclusive > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 row no-margin no-padding"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-6 no-padding mb-2"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.totalexcludingvat"
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-6 no-padding mb-2 text-right"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.getNumber(
                                                                _vm.total
                                                                  .untaxed
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm._l(_vm.taxResults, function(
                                              tax,
                                              index
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "col-12 row no-margin no-padding"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-6 no-padding mb-2"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            tax.displayText
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-6 no-padding mb-2 text-right"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.getNumber(
                                                              tax.total
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 row no-margin no-padding"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-6 no-padding"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.grandtotal"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-6 no-padding text-right"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        class: [
                                                          {
                                                            "text-underline-border": !_vm
                                                              .form
                                                              .switchWithHoldingTax
                                                          }
                                                        ]
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.getNumber(
                                                                _vm.total.grand
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.showLegacyWht()
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-12 row no-margin no-padding"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-12 no-padding"
                                                      },
                                                      [
                                                        _c("hr", {
                                                          staticStyle: {
                                                            "border-top":
                                                              "solid 1px #D8E2E7"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.showLegacyWht()
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-group row mb-0",
                                                  staticStyle: {
                                                    height: "35px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "col-8",
                                                      staticStyle: {
                                                        position: "relative",
                                                        top: "3px",
                                                        opacity: "0.3"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.showTooltipTaxHint = true
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("vs-switch", {
                                                        staticStyle: {
                                                          float: "left",
                                                          margin: "0 10px 0 0"
                                                        },
                                                        attrs: {
                                                          disabled: true,
                                                          color: "#A3CA76"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form
                                                              .switchWithHoldingTax,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "switchWithHoldingTax",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.switchWithHoldingTax"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.wht"
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-4" },
                                                    [
                                                      _vm.form
                                                        .switchWithHoldingTax
                                                        ? _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.form
                                                                      .inputWithHoldingTax,
                                                                  expression:
                                                                    "form.inputWithHoldingTax"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "custom-select form-control",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.disabledForm
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$selectedVal = Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                  _vm.$set(
                                                                    _vm.form,
                                                                    "inputWithHoldingTax",
                                                                    $event
                                                                      .target
                                                                      .multiple
                                                                      ? $$selectedVal
                                                                      : $$selectedVal[0]
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "0"
                                                                  }
                                                                },
                                                                [_vm._v("0%")]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "-1"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "message.wht1"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "-2"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "message.wht2"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "-3"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "message.wht3"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "-5"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "message.wht5"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.form.switchWithHoldingTax
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-12 row no-padding mt-2 ml-0 mr-0"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-12 row no-margin no-padding"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 no-padding mb-2"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "message.wht"
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 no-padding mb-2 text-right"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.getNumber(
                                                                      _vm.total.taxes.wht
                                                                        .toString()
                                                                        .replace(
                                                                          "-",
                                                                          ""
                                                                        )
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-12 row no-margin no-padding"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 no-padding"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "message.paymentamount"
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 no-padding text-right"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "text-underline-border"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getNumber(
                                                                        _vm
                                                                          .total
                                                                          .payment
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            !_vm.disabledForm
                              ? _c(
                                  "section",
                                  { staticClass: "action-bar" },
                                  [
                                    [
                                      !_vm.$store.state.app.loading
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 text-right"
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "btn btn-web",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.form.trickValidation++
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("button.save")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 text-right"
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-web btn-block-mobile-only",
                                                  attrs: { disabled: "" }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-spinner spin"
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                    ]
                                  ],
                                  2
                                )
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "ref",
                        fn: function() {
                          return [
                            _c(
                              "DocRef",
                              {
                                attrs: {
                                  refDoc: "so",
                                  refId: _vm.sale.so_id,
                                  refCode: _vm.sale.so_code,
                                  showLog:
                                    _vm.getSaleSetting.log_topic.is_active,
                                  showAttachFile:
                                    _vm.getSaleSetting.attach_file.is_active,
                                  logTopics:
                                    _vm.getSaleSetting.log_topic.options,
                                  isSubmitted: _vm.isSubmitted
                                }
                              },
                              [
                                _c("RefSO", {
                                  attrs: {
                                    sale: _vm.sale,
                                    disabled: !_vm.hasRoleCreate
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2203810435
                  )
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "confirmdeleteModal",
            tabindex: "-1",
            role: "dialog",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog", attrs: { role: "document" } },
            [
              _vm.ready
                ? _c("div", { staticClass: "modal-content" }, [
                    _c(
                      "div",
                      {
                        staticClass: "modal-header",
                        class: [
                          {
                            "no-border-bottom":
                              _vm.sale.reference.invoices.length == 0 &&
                              _vm.sale.reference.goodsissues.length == 0
                          }
                        ]
                      },
                      [
                        _c("h5", { staticClass: "modal-title" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("message.areyousuretodeletethis")) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        !_vm.$store.state.app.loading
                          ? _c(
                              "button",
                              {
                                staticClass: "close",
                                attrs: {
                                  type: "button",
                                  "aria-label": "Close"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.closeConfirmdeleteModal()
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { "aria-hidden": "true" } },
                                  [_vm._v("×")]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm.sale.reference.invoices.length > 0 ||
                    _vm.sale.reference.goodsissues.length > 0
                      ? _c("div", { staticClass: "modal-body" }, [
                          _c("p", { staticClass: "text-danger" }, [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.$t("message.refdocswillbedeleted"))
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.sale.reference.invoices.length > 0
                            ? _c("div", [
                                _c("p", { staticClass: "m-0" }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.$t("documents.in")) +
                                        " (" +
                                        _vm._s(
                                          _vm.sale.reference.invoices.length
                                        ) +
                                        ")"
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  _vm._l(_vm.sale.reference.invoices, function(
                                    invoice,
                                    index
                                  ) {
                                    return _c(
                                      "li",
                                      { key: index },
                                      [
                                        _c("router-link-custom", {
                                          attrs: {
                                            to: {
                                              name: "AccountsInvoiceEdit",
                                              query: {
                                                in_id: invoice.in_id,
                                                in_code: invoice.in_code
                                              }
                                            },
                                            text: invoice.in_code,
                                            status: {
                                              text: _vm.getInvoiceStatus(
                                                invoice,
                                                _vm.$t,
                                                _vm.mixin
                                              ).message,
                                              color: _vm.getColorFormStatus(
                                                _vm.getInvoiceStatus(
                                                  invoice,
                                                  _vm.$t,
                                                  _vm.mixin
                                                ).status
                                              ),
                                              type: "icon"
                                            },
                                            to_appid: 12,
                                            current_appid: 5
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.sale.reference.invoices.length > 0
                            ? _c("div", [
                                _c("p", { staticClass: "m-0" }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.$t("documents.pe")) +
                                        " (" +
                                        _vm._s(_vm.paymentsCount) +
                                        ")"
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  _vm._l(_vm.sale.reference.invoices, function(
                                    invoice,
                                    index
                                  ) {
                                    return _c(
                                      "li",
                                      { key: index },
                                      _vm._l(
                                        invoice.reference.payments,
                                        function(payment, index) {
                                          return _c(
                                            "div",
                                            { key: "payment-" + index },
                                            [
                                              _c("router-link-custom", {
                                                attrs: {
                                                  to: {
                                                    name:
                                                      "AccountsPaymentEntryEdit",
                                                    query: {
                                                      pe_id: payment.pe_id,
                                                      pe_code: payment.pe_code
                                                    }
                                                  },
                                                  text: payment.pe_code,
                                                  status: {
                                                    text: _vm.getPaymentStatus(
                                                      payment,
                                                      _vm.$t
                                                    ).message,
                                                    color: _vm.getColorFormStatus(
                                                      _vm.getPaymentStatus(
                                                        payment,
                                                        _vm.$t
                                                      ).status
                                                    ),
                                                    type: "icon"
                                                  },
                                                  to_appid: 12,
                                                  current_appid: 4
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  }),
                                  0
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.sale.reference.goodsissues.length > 0
                            ? _c("div", [
                                _c("p", { staticClass: "m-0" }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.$t("documents.gi")) +
                                        " (" +
                                        _vm._s(
                                          _vm.sale.reference.goodsissues.length
                                        ) +
                                        ")"
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  _vm._l(
                                    _vm.sale.reference.goodsissues,
                                    function(goodsissue, index) {
                                      return _c(
                                        "li",
                                        { key: index },
                                        [
                                          _c("router-link-custom", {
                                            attrs: {
                                              to: {
                                                name: "GoodsIssueEdit",
                                                query: {
                                                  gi_id: goodsissue.gi_id,
                                                  gi_code: goodsissue.gi_code
                                                }
                                              },
                                              text: goodsissue.gi_code,
                                              status: {
                                                text: _vm.getGoodsIssueStatus(
                                                  goodsissue,
                                                  _vm.$t
                                                ).message,
                                                color: _vm.getColorFormStatus(
                                                  _vm.getGoodsIssueStatus(
                                                    goodsissue,
                                                    _vm.$t
                                                  ).status
                                                ),
                                                type: "icon"
                                              },
                                              to_appid: 3,
                                              current_appid: 5
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.$store.state.app.loading
                      ? _c("div", { staticClass: "modal-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-light",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.closeConfirmdeleteModal()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-danger",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.del()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("button.delete")))]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$store.state.app.loading
                      ? _c("div", { staticClass: "modal-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-light",
                              attrs: { type: "button", disabled: "" }
                            },
                            [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                          ),
                          _vm._v(" "),
                          _vm._m(0)
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "printModal",
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg-90-percent",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-body p-0",
                    staticStyle: {
                      background: "#C9CCCE",
                      height: "660px",
                      overflow: "auto"
                    }
                  },
                  [
                    _vm.ready
                      ? _c("printsale-view", {
                          staticClass: "print-template",
                          attrs: {
                            sale: _vm.sale,
                            fontSize: _vm.getSaleSetting.doc_template.font_size,
                            isFixedSignatureBottom:
                              _vm.getSaleSetting.doc_template
                                .is_fixed_signature_bottom
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-web",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.onclickPrint()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.print")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.closePrintModal()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.close")))]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "sharelinkModal",
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("button.sharelink")) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.$store.state.app.loading
                    ? _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button", "aria-label": "Close" },
                          on: {
                            click: function($event) {
                              return _vm.closeShareLinkModal()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "section",
                    { staticClass: "link" },
                    [
                      _c("section-title", {
                        attrs: { title: _vm.$t("message.link") }
                      }),
                      _vm._v(" "),
                      _vm._m(1)
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    { staticClass: "mb-0" },
                    [
                      _c("section-title", {
                        attrs: { title: _vm.$t("message.permissions") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-12 p-0" }, [
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col-6" }, [
                            _c("div", { staticClass: "form-group row mb-2" }, [
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticStyle: {
                                        float: "left",
                                        margin: "0"
                                      },
                                      attrs: { color: "#A3CA76" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("button.download")))]
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group row mb-0" }, [
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticStyle: {
                                        float: "left",
                                        margin: "0"
                                      },
                                      attrs: { color: "#A3CA76" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("message.approve")))]
                                  )
                                ],
                                1
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6" }, [
                            _c("div", { staticClass: "form-group row mb-2" }, [
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticStyle: {
                                        float: "left",
                                        margin: "0"
                                      },
                                      attrs: { color: "#A3CA76" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("button.print")))]
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.closeShareLinkModal()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.close")))]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      }),
      _vm._v(" "),
      _c("BaseConfirmCloneModal", {
        attrs: {
          show: _vm.modalConfirmClone.show,
          loading: _vm.modalConfirmClone.loading
        },
        on: {
          onClose: _vm.handleCloseCloneModal,
          onCancel: _vm.handleCancleCloneModal,
          onConfirm: function($event) {
            return _vm.handleConfirmCloneModal({
              payload: _vm.payloadClone,
              createApiFn: _vm.insertSale,
              redirectTo: "SaleOrderAll",
              refCode: "sale.so_code"
            })
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-danger",
        attrs: { type: "button", disabled: "" }
      },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 p-0 wrapper-link" }, [
      _c("input", {
        staticClass: "form-control text-clipboard",
        attrs: {
          id: "sharelink",
          type: "text",
          readonly: "readonly",
          value: "https://doc.treesoft.io/th/eWRhpRV"
        }
      }),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-sm btn-secondary",
          staticStyle: { right: "59px" },
          attrs: {
            href: "https://doc.treesoft.io/th/eWRhpRV",
            target: "_blank"
          }
        },
        [_vm._v("ไปยัง")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-secondary btn-copy",
          staticStyle: { right: "7px" },
          attrs: { "data-ref": "sharelink" }
        },
        [_vm._v("คัดลอก")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a7f96ad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a7f96ad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/sales/so/Edit.vue
// module id = null
// module chunks = 